<template>
  <div class="headerBox">
    <!--头部模块-->
    <header class="header w" id="fixedCard" :class="{'isFixed':fixed}">
      <div class="middleHeader" style="width: 1440px;height:62px;margin:0 auto;position: relative;">

        <!--logo部分-->
        <div class="logo" @click="toHome()"><img src="../assets/img/SmoothsoundLOGO.png"/></div>
        <!--导航栏部分-->
        <div class="hotwords">
          <Menu ref="menu" mode="horizontal" :active-name="menuIndex" @on-select="selectMenu" style="background: none">
            <MenuItem name="1">
              首页
            </MenuItem>
            <MenuItem name="2">
              定制开发
            </MenuItem>
            <MenuItem name="3">
              客户案例
            </MenuItem>
            <MenuItem name="4">
              关于我们
            </MenuItem>
          </Menu>
          <div class="contactUs" @click="toBottom()">
            联系我们
          </div>
        </div>
        <div class="linePhone">
          咨询热线：13391444013
        </div>
      </div>

    </header>
  </div>

</template>
<script >
  import '@/assets/sass/header.css'
  import eventBus from "@/assets/js/eventBus"
  export default {
    name: 'headers',
    data() {
      return {
        menuIndex: "1",
        index: '',
        fixed:true,
      }
    },
    watch:{},
    created(){
      this.$nextTick(()=>{
        eventBus.$on("header",(data)=>{
          this.menuIndex= data+""
        })
        if(window.location.pathname=='/aboutUs'){
           this.menuIndex ="4"
        }else if(window.location.pathname=='/'){
           this.menuIndex ="1"
        }else if(window.location.pathname=='/customDev'){
           this.menuIndex = "2"
        }else if(window.location.pathname=='/customerCase'){
          this.menuIndex = "3"
        }else if(window.location.pathname=='/customerCaseDetails'){
          this.menuIndex = "3"
        }
      })
    },
    methods: {
      toBottom(){
        window.scrollTo({
          top: document.documentElement.scrollHeight,
          behavior: 'smooth'
        });
      },
      selectMenu(index){
         if(index==1) {
            window.location.href='/'
        }else if(index==2){
          // window.location.href='/enterpriseSolution.html'
          //  this.$router.push('/customDev')
           window.location.href='/customDev'
         }else if(index==3){
          // window.location.href='/case-esolution.html'
          //  this.$router.push('/customerCase')
           window.location.href='/customerCase'
         }else if(index==4){
          // this.$router.push('/aboutUs')
           window.location.href='/aboutUs'
         }
      },
      toHome(){
        eventBus.$emit("header",1);
        window.location.href='/'
        this.menuIndex ="1";
        document.getElementById("app").scrollIntoView();
      },
    },
    beforeDestroy() {
      eventBus.$off("header")
    }
  }
</script>
<style scoped>
.logo:hover{
  cursor: pointer;
}
.isFixed {
  position: fixed !important;
  /*background-color: #ffffff;*/
  top: 0;
  z-index: 999;
  width: 100%;
  background: rgba(255,255,255,0.8000);
  box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.0500);
  backdrop-filter: blur(10px);
  /*margin: 0 auto;*/
}
  .headerBox{
    width:100%;
    height:62px;
  }
</style>



// WEBPACK FOOTER //
// src/components/headers.vue